import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { ICampaign } from '../../interfaces/i-campaign';
import { DeepLinkService } from '../../services/deep-link.service';
import { DL_CAMPAIGN_URL, DL_DELIVERY_URL } from '../../utils/consts';
import { CampaignOfferType } from '../../utils/enuns/campaign-offer-type-enum';

@Component({
  selector: 'mobo-coupon',
  templateUrl: './coupon.component.html',
  styles: [],
})
export class CouponComponent {
  public defaultImg = environment.defaultImg;
  private _campaign?: ICampaign;
  @Output() redirectToRestaurant = new EventEmitter();
  public get campaign(): ICampaign | null {
    return this._campaign || null;
  }
  @Input()
  public set campaign(v: ICampaign) {
    this._campaign = v;
    this.checkScarcityLevel();
  }

  @Input() direction?: any = 'ver';

  public offerTypeEnum = CampaignOfferType;
  public scarcityLevels = {
    low: {
      color: 'text-[#069E52]',
      label: 'Baixa',
    },
    medium: {
      color: 'text-[#FF7F11]',
      label: 'Média',
    },
    high: {
      color: 'text-[#F2530E]',
      label: 'Alta',
    },
    very_high: {
      color: 'text-[#D81F1F]',
      label: 'Muito Alta',
    },
  };

  public scarcityLevel = this.scarcityLevels.low;
  constructor(
    private toastr: ToastrService,
    private deepLinkService: DeepLinkService
  ) {}

  public redirectToRestaurantEmitter() {
    this.redirectToRestaurant.emit();
  }

  public deeplinkRedirect(campaign: any) {
    if (!campaign) return;
    this.deepLinkService.deeplinkRedirect(campaign.Id, campaign.IsDelivery);
  }

  public checkScarcityLevel() {
    const val = this.campaign?.CouponDailyCount || 0;
    if (val == 1) {
      this.scarcityLevel = this.scarcityLevels.very_high;
    } else if (val > 1 && val <= 5) {
      this.scarcityLevel = this.scarcityLevels.high;
    } else if (val > 5 && val <= 9) {
      this.scarcityLevel = this.scarcityLevels.medium;
    } else {
      this.scarcityLevel = this.scarcityLevels.low;
    }
  }

  public copyUrl(campaign: any) {
    if (!campaign) return;

    const deepLinkUrl = `${
      campaign.IsDelivery ? DL_DELIVERY_URL : DL_CAMPAIGN_URL
    }${campaign.Id}`;

    navigator.clipboard
      .writeText(deepLinkUrl)
      .then(() => {
        this.toastr.success(
          'Link copiado para a área de transferência!',
          'Sucesso'
        );
      })
      .catch((err) => {
        this.toastr.error('Erro ao copiar o link', 'Erro');
      });
  }
}
